import { ref as h, computed as m } from "vue";
import { BREAKPOINTS as n, DIRECTION as t } from "./breakpoints.js";
class o {
  /**
   * Computed Boolean for reacting to the 'SM-' or 'mobile' class of screen sizes.
   */
  isSmallOrSmaller;
  /**
   * Computed Boolean for reacting to the 'MD+' or 'desktop' class of screen sizes.
   */
  isMediumOrLarger;
  /**
   * Computed String that is the current size of the user agent's screen.
   */
  size;
  /**
   * Reactive variable for screen width
   */
  screenWidth;
  constructor() {
    this.screenWidth = h(window.innerWidth), window.addEventListener("resize", () => {
      this.screenWidth.value = window.innerWidth;
    }), this.size = m(() => this.calculateScreenSize()), this.isSmallOrSmaller = this.inRange(n.SM, t.SMALLER), this.isMediumOrLarger = this.inRange(n.MD, t.LARGER);
  }
  /**
   * Returns a computed property that is true when the current screen size is in the given range, false otherwise.
   * See also; the "breakpoint" mixin of sass-base
   *
   * To help this function match the API of the sass-base breakpoint mixin, it accepts a range so that you can provide
   * `BREAKPOINTS.MD` as an input, rather than us needing to export some sort of BREAKPOINT_NAME enumeration. This opens
   * this function up to the possibility of passing in a custom range, which is not officially supported. You should
   * always call this function with one of the BREAKPOINTS
   *
   * @param rangeStart The name of the breakpoint that defines one end of your breakpoint range, inclusive
   * @param rangeEnd If the name of the breakpoint, the other end of your breakpoint range, inclusive.
   *   If a direction, then the interval is open-ended in that direction.
   *   If undefined, then the 'range' is exactly the specified rangeStart's dimensions.
   * @returns a computed property that is true when the current screen size is in the given range, false otherwise.
   */
  inRange(i, e) {
    return m(() => {
      let s, r;
      return e === void 0 ? (s = i.min, r = i.max) : e === t.LARGER ? (s = i.min, r = Number.POSITIVE_INFINITY) : e === t.SMALLER ? (s = Number.NEGATIVE_INFINITY, r = i.max) : (s = Math.min(i.min, e.min), r = Math.max(i.max, e.max)), s <= this.screenWidth.value && this.screenWidth.value <= r;
    });
  }
  /**
   * Calculates the current screensize of the user agent
   *
   * @returns the screensize as a string.
   */
  calculateScreenSize() {
    const i = Object.entries(n).find(
      (e) => e[1].min <= this.screenWidth.value && this.screenWidth.value <= e[1].max
    );
    if (i === void 0)
      throw new Error("Couldn't find a breakpoint");
    return i[0];
  }
}
export {
  o as ScreenSize
};
//# sourceMappingURL=screensize.js.map
